import type { CreateSchemaAction } from '@cli-types/next-adapter/commands.js'
import { CREATE_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { promptSelectValue } from '../schema-prompts/prompt-select-value.js'

export async function promptCreateSchemaAction(): Promise<CreateSchemaAction> {
  return promptSelectValue<CreateSchemaAction>(
    CREATE_PROMPT_CONTEXT,
    'Write schema JSON and generate this schema?',
    [
      { value: 'write', label: 'Yes' },
      { value: 'addMore', label: 'Add more' },
      { value: 'cancel', label: 'Cancel' }
    ],
    'write'
  )
}
